import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  title: "",
  description: "",
  eventCategory: "",
  mode: "",
  startDate: "",
  endDate: "",
  startTime: "",
  endTime: "",
  pageUrl: "",
  meetLink: "",
  address: "",
  locationName: "",
  maxAttendees: 0,
  speakers: [],
  requireApproval: 0,
  hashTag: [],
  media: [],
  isPrimary: 1,
  content: "",
  coverImage: null,
  thumbnailImage: null,
  eventId: null,
  locationId: "",
  formattedAddress: "",
};

export const createUserEventSlice = () => {
  const userEventSlice = createSlice({
    name: "userEvent",
    initialState,
    reducers: {
      setUserEvent: (state, action) => {
        return action.payload;
      },
      resetUserEvent: () => {
        return initialState;
      },
    },
  });

  return userEventSlice;
};


const eventStatusSlice = createSlice({
  name: 'eventStatus',
  initialState: {},
  reducers: {
    setEventStatus: (state, action) => {
      const { eventId, status } = action.payload;
      state[eventId] = status;
    },
  },
});

export const { setEventStatus } = eventStatusSlice.actions;
export const eventStatusReducer = eventStatusSlice.reducer;